/** `/pending`: shown to an onboarded but not-yet-validated volunteer. */
import { useState } from 'react';

import { useAuth } from '../auth/AuthContext';
import { Button, Card } from '../components/ui';
import { t } from '../i18n/fr';

/**
 * Render the "awaiting validation" screen, with a manual refresh action
 * (an admin may have validated the account since the page loaded).
 *
 * @returns The page element.
 */
export function PendingPage() {
  const { refresh, logout } = useAuth();
  const [checking, setChecking] = useState(false);

  async function onRefresh() {
    setChecking(true);
    try {
      await refresh();
    } finally {
      setChecking(false);
    }
  }

  return (
    <div className="auth-screen">
      <Card>
        <h1>{t('auth.pending.title')}</h1>
        <p>{t('auth.pending.body')}</p>
        <Button type="button" fullWidth disabled={checking} onClick={() => void onRefresh()}>
          {checking ? t('common.loading') : t('auth.pending.refresh')}
        </Button>
        <p>
          <button type="button" className="ui-btn ui-btn--ghost" onClick={() => void logout()}>
            {t('auth.pending.logout')}
          </button>
        </p>
      </Card>
    </div>
  );
}
